import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ReplaySubject, Subscription } from 'rxjs';
import { MondelezDataService } from '../../services/mondelez-data.service';
import { GlobalFilter, KPIDashboardScreen, SupplyMode, InsightMode } from '../../interfaces/global-filter-model';
import * as _ from 'underscore';
import { MatOption } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/core/services/global.service';
import { GlobalFilterService } from '../../services/global-filter.service';

@Component({
  selector: 'app-global-filter',
  templateUrl: './global-filter.component.html',
  styleUrls: ['./global-filter.component.scss'],
})
export class GlobalFilterComponent implements OnInit, OnDestroy {
  @ViewChild('allSelectedCategpry') public allSelectedCategpry: MatOption;
  @ViewChild('allSelectedB') public allSelectedB: MatOption;
  @ViewChild('allSelectedNetwork') public allSelectedNetwork: MatOption;
  @ViewChild('allSelectedplant_code') public allSelectedplant_code: MatOption;
  @ViewChild('allSelectednode_code') public allSelectednode_code: MatOption;
  @ViewChild('allSelectednode_type') public allSelectednode_type: MatOption;
  @ViewChild('allSelectedgeography') public allSelectedgeography: MatOption;
  @ViewChild('allSelectedFirm') public allSelectedFirm: MatOption;

  @Input() initiateFromDialog = false;

  private subscriptions = new Subscription();

  public filterForm: FormGroup;

  public isSupplyModeToggleVisible: boolean = false;
  public isKPIModeToggleVisible: boolean = false;
  public isInsightToggleVisible: boolean = false;
  public clearFirmType: boolean = false;
  public mapViewScreen: boolean = false;

  public currentFilter: any;
  public initialFiltersValues: any = {};
  public filterIconFlag: any = {};
  public userScreens = [];
  public filterMasterData: any = [];
  public masterData: any;

  public supply_mode = SupplyMode.MANUFACTURING;
  public insight_mode: InsightMode;
  public kpi_screen: string;

  public historicalStartYear: string;
  public geographyOptions: any = [];

  public supplyModeParam = [
    { key: 'manufacturing', description: 'Manufacturing', isDisabled: true },
    { key: 'logistics', description: 'Logistics', isDisabled: true },
  ];

  public insightScreenParam = [
    { key: 'mups', description: 'MUPs', isDisabled: true },
    { key: 'commercial_insights', description: 'Commercial Insights', isDisabled: true },
  ];

  public kpiScreenParam = [
    { key: 'financial', description: 'Financial', isDisabled: true },
    { key: 'operational', description: 'Operational', isDisabled: false },
  ];

  public manufacturingFilters = {
    firm_type: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    category: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    brand: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    manufacturing_network: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    geography: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
  };

  public nodeFilters = {
    node_type: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    node_code: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    geography: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
    plant_code: {
      formControl: new FormControl<any>(null),
      filterCtrl: new FormControl<string>(''),
      filtered: new ReplaySubject<any[]>(1),
      values: [],
    },
  };

  constructor(
    private fb: FormBuilder,
    private mondelezDataService: MondelezDataService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private globalService: GlobalService,
    public globalFilterService: GlobalFilterService
  ) {}

  ngOnInit(): void {
    this.userScreens = this.globalService.getNavList();
    this.currentFilter = this.globalFilterService.currentFilters;
    this.createForm();
    if (this.globalFilterService.getFilterMasterData()) {
      // this.filteredList = this.globalFilterService.getFilterMasterData();
      // this.skuMaster = this.globalFilterService.getFilterMasterData().sku_master;
      // this.nodeMaster = this.globalFilterService.getFilterMasterData().node_master;
      // this.plantMaster = this.globalFilterService.getFilterMasterData().plant_master;
      this.masterData = this.globalFilterService.getFilterMasterData();
      this.filterMasterData = this.masterData['filters'];
      // this.initFilterData(this.skuMaster, '', this.manufacturingFilters);
      // this.initFilterData(this.nodeMaster, '', this.nodeFilters);
      this.historicalStartYear = this.masterData['hist_start_year'];
    }
    this.initializeValues();

    _.each(this.manufacturingFilters, (value, key) => {
      this.manufacturingFilters[key].filterCtrl.valueChanges.subscribe(() => {
        this.filterFilters(key, this.manufacturingFilters);
      });
    });
    _.each(this.nodeFilters, (value, key) => {
      this.nodeFilters[key].filterCtrl.valueChanges.subscribe(() => {
        this.filterFilters(key, this.nodeFilters);
      });
    });
  }

  public createForm() {
    this.filterForm = this.fb.group({
      firm_type: [null],
      category: [null],
      brand: [null],
      manufacturing_network: [null],
      start_year: null,
      end_year: null,
      node_type: [null],
      plant_code: [null],
      node_code: [null],
      geography: [null],
    });
  }

  initializeValues() {
    this.subscriptions.add(
      this.globalFilterService.filterMasterData.subscribe({
        next: (data) => {
          if (data) {
            this.masterData = data;
            this.historicalStartYear = data['hist_start_year'];
            this.filterMasterData = data['filters'];

            this.geographyOptions = _.sortBy(_.uniq(_.pluck(this.filterMasterData, 'geography')));
            if (!this.initiateFromDialog) {
              this.currentFilter = undefined;
              this.filterForm.reset();
              // this.initFilterData(this.filterMasterData, '', this.manufacturingFilters);
              // this.initFilterData(this.filterMasterData, '', this.nodeFilters);
            }
            this.initFilterData(this.filterMasterData, '', this.manufacturingFilters);
            this.initFilterData(this.filterMasterData, '', this.nodeFilters);

            this.filterForm.patchValue({
              start_year: data.start_year,
              end_year: data.end_year,
            });
            if (this.currentFilter) {
              this.filterForm.patchValue({ ...this.currentFilter });
            }
            if (!this.initiateFromDialog) {
              this.globalFilterService.updateGlobalFiltersSelection(this.filterForm.value);
            }
          }
        },
      })
    );

    this.subscriptions.add(
      this.mondelezDataService.kpiScreen.subscribe((value) => {
        this.kpi_screen = value;
        if (this.kpi_screen === KPIDashboardScreen.FINANCIAL) {
          this.isKPIModeToggleVisible = true;
          this.isSupplyModeToggleVisible = false;
        } else if (this.kpi_screen === KPIDashboardScreen.OPERATIONAL) {
          this.isKPIModeToggleVisible = true;
          this.isSupplyModeToggleVisible = true;
        } else {
          this.isKPIModeToggleVisible = false;
        }

        this.setSupplyModeTogglerVisibility();
      })
    );

    this.subscriptions.add(
      this.mondelezDataService.supplyMode.subscribe((value: SupplyMode) => {
        this.supply_mode = value;
        const currentScreen = this.router.url.split('/')[2];
        const accessList = this.userScreens.filter((el) => el.screen_name === currentScreen && el.is_active).map((el) => el.supply_mode);
        this.supplyModeParam.map((el) => {
          if (accessList.includes(el.key)) {
            el.isDisabled = false;
          } else {
            el.isDisabled = true;
          }
          return el;
        });
        this.insightScreenParam.map((el) => {
          if (accessList.includes(el.key)) {
            el.isDisabled = false;
          } else {
            el.isDisabled = true;
          }
          return el;
        });
        this.kpiScreenParam.map((el) => {
          if (accessList.includes(el.key)) {
            el.isDisabled = false;
          }
          return el;
        });

        this.setSupplyModeTogglerVisibility();
      })
    );

    this.subscriptions.add(
      this.mondelezDataService.insightMode.subscribe((value: InsightMode) => {
        this.insight_mode = value;
        this.setSupplyModeTogglerVisibility();
      })
    );

    this.subscriptions.add(
      this.globalFilterService.globalFilters.subscribe((value: GlobalFilter) => {
        if (value) {
          this.filterForm.patchValue({ ...value });
          setTimeout(() => {
            this.applyFilter();
          }, 1000);
        }
      })
    );
  }

  setSupplyModeTogglerVisibility() {
    if (this.isKPIModeToggleVisible) {
      this.isInsightToggleVisible = false;
      if (this.kpi_screen === null || this.kpi_screen === 'financial') {
        this.isSupplyModeToggleVisible = false;
      } else {
        this.isSupplyModeToggleVisible = true;
      }
    } else if (this.insight_mode) {
      this.isKPIModeToggleVisible = false;
      this.isSupplyModeToggleVisible = false;
      this.isInsightToggleVisible = true;
    } else {
      this.isKPIModeToggleVisible = false;
      this.isInsightToggleVisible = false;
      this.isSupplyModeToggleVisible = this.initiateFromDialog ? false : true;
    }
  }

  onKpiScreenChange(screen: KPIDashboardScreen) {
    this.kpi_screen = screen;
    this.router.navigate([screen], { relativeTo: this.activeRoute.firstChild });
  }

  onSupplyModeChange(mode: SupplyMode): void {
    this.supply_mode = mode;
    if (this.isKPIModeToggleVisible) {
      this.router.navigate([mode], { relativeTo: this.activeRoute.firstChild.firstChild });
    } else {
      this.router.navigate([mode], { relativeTo: this.activeRoute.firstChild });
    }
  }

  onInsightModeChange(mode: InsightMode): void {
    this.insight_mode = mode;
    if (this.isKPIModeToggleVisible) {
      this.router.navigate([mode], { relativeTo: this.activeRoute.firstChild.firstChild });
    } else {
      this.router.navigate([mode], { relativeTo: this.activeRoute.firstChild });
    }
  }

  handleOpenedChange(isOpened, formFiled) {
    this.filterIconFlag[formFiled] = isOpened;
    if (isOpened) {
      this.setInitialFilterFormValues(formFiled);
    } else {
      this.clearFirmType = this.filterForm.controls['firm_type'].value !== null;
      if (this.initialFiltersValues.hasOwnProperty(formFiled)) {
        const initialValue = this.initialFiltersValues[formFiled];
        const currentValue = this.filterForm.controls[formFiled].value;
        if ((initialValue === null && (currentValue === null || (Array.isArray(currentValue) && currentValue.length === 0))) === false) {
          const valueChanged = this.isValueChanged(initialValue, currentValue);
          this.applyFilter();
          if (valueChanged) {
            this.globalFilterService.updateGlobalFiltersSelection(this.filterForm.value);
          }
        }
      }
    }
  }

  setInitialFilterFormValues(formFiled) {
    this.initialFiltersValues[formFiled] = this.filterForm.controls[formFiled].value;
  }

  isValueChanged(initialValue: any, currentValue: any): boolean {
    if (Array.isArray(initialValue) && Array.isArray(currentValue)) {
      if (initialValue.length !== currentValue.length) {
        return true;
      } else {
        return !initialValue.every((element) => {
          if (currentValue.includes(element)) {
            return true;
          }
          return false;
        });
      }
    } else {
      return initialValue !== currentValue;
    }
  }

  protected filterFilters(field, filterFormObj) {
    if (!filterFormObj[field].values) {
      return;
    }
    // get the search keyword
    let search = filterFormObj[field].filterCtrl.value;
    if (!search) {
      filterFormObj[field].filtered.next(filterFormObj[field].values.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filterFormObj[field].filtered.next(filterFormObj[field].values.filter((el) => el.toLowerCase().indexOf(search) > -1));
  }

  public initFilterData(data, formField, filters) {
    _.each(filters, (value, key) => {
      if (key != formField) {
        let dataList;
        //.. for kpi screen sho location dropdown for just plant type node_code
        if (this.isKPIModeToggleVisible && key === 'plant_code' && this.supply_mode != 'logistics') {
          // const plantData = this.plantMaster;
          const plantData = this.filterMasterData;
          dataList = _.sortBy(_.uniq(_.pluck(plantData, 'node_code')));
        } else {
          if (key == 'geography') {
            // dataList = _.sortBy(_.uniq(_.pluck(this.nodeMaster, key)));
            dataList = _.sortBy(_.uniq(_.pluck(this.filterMasterData, key)));
          } else {
            dataList = _.sortBy(_.uniq(_.pluck(data, key)));
          }
        }
        filters[key].values = dataList;
        filters[key].filtered.next(dataList.slice());
      }
    });
  }

  applyFilter() {
    const category = this.filterForm.value['category'] || [];
    const brand = this.filterForm.value['brand'] || [];
    const manufacturing_network = this.filterForm.value['manufacturing_network'] || [];
    const plant_code = this.filterForm.value['plant_code'] || [];
    const node_code = this.filterForm.value['node_code'] || [];
    const node_type = this.filterForm.value['node_type'] || [];
    const firm_type = this.filterForm.value['firm_type'] || [];

    let filters: any = [];
    let keys: any = [];
    let masterData: any = [];
    if (this.supply_mode == SupplyMode.MANUFACTURING || this.isInsightModeActive()) {
      filters = [
        { key: 'category', values: category },
        { key: 'brand', values: brand },
        { key: 'manufacturing_network', values: manufacturing_network },
        { key: 'firm_type', values: firm_type },
      ];
      keys = ['category', 'brand', 'manufacturing_network', 'firm_type'];
      // masterData = JSON.parse(JSON.stringify(this.skuMaster));
      masterData = structuredClone(this.filterMasterData);
    } else {
      filters = [
        { key: 'plant_code', values: plant_code },
        { key: 'node_code', values: node_code },
        { key: 'node_type', values: node_type },
      ];
      keys = ['plant_code', 'node_code', 'node_type'];
      // masterData = JSON.parse(JSON.stringify(this.nodeMaster));
      masterData = structuredClone(this.filterMasterData);
    }

    // const filteredData = masterData.filter((item) => {
    //   return filters.every((filter) => {
    //     if (filter.values.length === 0) return true;
    //     return filter.values.includes(item[filter.key]);
    //   });
    // });

    keys.forEach((key) => {
      const temp = masterData?.filter((item) => {
        return filters
          .filter((filter) => filter.key !== key)
          .every((filter) => {
            if (filter.values.length === 0) return true;
            return filter.values.includes(item[filter.key]);
          });
      });

      const uniqueValues = _.sortBy(_.uniq(this.getkeysfilter(key, structuredClone(temp))));
      if (this.supply_mode == SupplyMode.MANUFACTURING || this.isInsightModeActive()) {
        setTimeout(() => {
          this.manufacturingFilters[key].values = uniqueValues;
          this.manufacturingFilters[key].filtered.next(uniqueValues);
        }, 200);
      } else {
        setTimeout(() => {
          this.nodeFilters[key].values = uniqueValues;
          this.nodeFilters[key].filtered.next(uniqueValues);
        }, 200);
      }
    });
  }

  getkeysfilter(key, data) {
    return data.map((ele) => ele[key]);
  }

  toggleAllSelection(formField, alloptions) {
    let masterData: any;
    if ((this.supply_mode == SupplyMode.MANUFACTURING && (formField != 'node_code' || formField != 'plant_code')) || this.isInsightModeActive()) {
      masterData = this.manufacturingFilters;
    } else {
      masterData = this.nodeFilters;
    }
    if (alloptions.selected) {
      let allOptions = [];
      masterData[formField].filtered.subscribe((res) => {
        allOptions = res;
      });
      let newValues = allOptions.map((item) => {
        return item;
      });
      newValues.push('');
      const temp = this.filterForm.get(formField);
      temp.patchValue([...newValues]);
    } else {
      const temp = this.filterForm.get(formField);
      temp.patchValue([]);
    }
  }

  togglePerOne(formField, alloptions) {
    let masterData: any;
    if (this.supply_mode == SupplyMode.MANUFACTURING || this.isInsightModeActive()) {
      masterData = this.manufacturingFilters;
    } else {
      masterData = this.nodeFilters;
    }
    if (alloptions.selected) {
      alloptions.deselect();
      return false;
    }
    const temp = this.filterForm.get(formField);
    let allOptions = [];
    masterData[formField].filtered.subscribe((res) => {
      allOptions = res;
    });
    if (temp.value && temp.value.length == allOptions.length) alloptions.select();
    return '';
  }

  onClearFilter() {
    this.filterForm.reset();
    this.filterForm.patchValue({
      start_year: this.masterData.start_year,
      end_year: this.masterData.end_year,
    });
    // this.mondelezDataService.filterCleared.next(true);
    this.globalFilterService.updateGlobalFiltersSelection(this.filterForm.value);
    this.initFilterData(this.filterMasterData, '', this.manufacturingFilters);
    this.initFilterData(this.filterMasterData, '', this.nodeFilters);
  }

  // clearSelection(event) {
  //   event.stopPropagation();
  //   this.filterForm.get('firm_type').patchValue(null);
  //   this.globalFilterService.updateGlobalFiltersSelection(this.filterForm.value);
  //   this.applyFilter();
  //   this.clearFirmType = this.filterForm.controls['firm_type'].value !== null;
  // }

  onYearsSelected(eventData: { year1; year2 }) {
    this.filterForm.patchValue({
      start_year: eventData.year1,
      end_year: eventData.year2,
    });
    this.globalFilterService.updateGlobalFiltersSelection(this.filterForm.value);
  }

  isInsightModeActive() {
    let insightModeVisibility = false;
    if (this.insight_mode == InsightMode.COMMERCIAL_INSIGHTS || this.insight_mode == InsightMode.MUPS) {
      insightModeVisibility = true;
    }
    return insightModeVisibility;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    if (!this.initiateFromDialog) {
      this.globalFilterService.resetFilters();
    }
  }
}
